import { newSecretManagerElement } from "@p0security/integrations-vaulted-credential-shared";
import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

const allSecretManagers = newSecretManagerElement({
  owner: "GitLab group",
  connector: "GitLab",
});

const secretManager = Element({
  ...allSecretManagers,
  default: "gcp-sm",
});

// The connector's IAM condition matches the id up to the next `_` in each GCP
// secret name, where `/` becomes `_` and `.` becomes `-`.
const ITEM_ID_PATTERN = /^[A-Za-z0-9-]+$/;

export const GitlabAiComponents = InstallSpec({
  credential: ItemComponent({
    label: "Credential provisioning",
    description: "Allow P0 to grant machines access to GitLab",
    type: "string",
    maturity: "beta",
    validator: async (_context: unknown, id: string) =>
      ITEM_ID_PATTERN.test(id)
        ? undefined
        : "Use only letters, digits and hyphens",
    schema: {
      secretManager,
      groupId: Element({
        label: "Group ID",
        description:
          "ID of the GitLab.com top-level group, shown on the group's overview page. P0 creates one service account in it for each grant.",
        type: "string",
      }),
    },
  }),
});
